import { render, staticRenderFns } from "./svgAparat.vue?vue&type=template&id=192ad035&scoped=true"
import script from "./svgAparat.vue?vue&type=script&lang=js"
export * from "./svgAparat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ad035",
  null
  
)

export default component.exports